// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__xeZJJ","rotation":"spinner_rotation__nqYgD"};